import { Link } from "react-router-dom";
import { useInView } from "@/hooks/useInView";

export default function ClosingCTA() {
  const { ref, inView } = useInView<HTMLElement>({ threshold: 0.25 });

  return (
    <section
      ref={ref}
      className="relative h-[60vh] min-h-[480px] w-full overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20sunlit%20farmhouse%20living%20room%20at%20golden%20hour%20with%20a%20linen%20draped%20sofa%20a%20handmade%20wool%20throw%20a%20worn%20oak%20coffee%20table%20with%20a%20stoneware%20mug%20and%20a%20single%20beeswax%20candle%20wide%20plank%20floors%20warm%20natural%20afternoon%20light%20muted%20cream%20honey%20and%20sage%20palette%20editorial%20documentary%20photography%20soft%20shadows%20simple%20uncluttered%20composition%20cozy%20heirloom%20mood&width=2000&height=1100&seq=closing-cta-home-1&orientation=landscape"
        alt="Heirloom goods at home"
        title="Hearth & Heirloom — slow-made home goods"
        className={`absolute inset-0 w-full h-full object-cover object-center transition-transform duration-[2200ms] ease-out ${
          inView ? "scale-100" : "scale-110"
        }`}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/30 to-black/55" />
      <div className="relative h-full w-full flex flex-col items-center justify-center text-center px-4">
        <p
          className={`text-background-50/80 text-xs md:text-sm tracking-[0.3em] uppercase mb-4 transition-all duration-1000 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
          }`}
        >
          Welcome home
        </p>
        <h2
          className={`font-heading text-background-50 text-4xl md:text-6xl lg:text-7xl leading-[1.05] max-w-3xl transition-all duration-1000 delay-150 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          Bring something
          <br />
          worth keeping.
        </h2>
        <div
          className={`mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-3 md:gap-4 transition-all duration-1000 delay-300 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
          }`}
        >
          <Link
            to="/#collections"
            className="inline-flex items-center gap-2 px-6 h-11 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 cursor-pointer whitespace-nowrap group"
          >
            Shop the collection
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            to="/artisans"
            className="inline-flex items-center gap-2 px-6 h-11 rounded-full border border-background-50/50 text-background-50 text-sm hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
          >
            Meet the makers
          </Link>
        </div>
      </div>
    </section>
  );
}